// CANONICAL COPY (GH #7115). src/constants/obligations/obl-management-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-management-review',
  title: 'Conduct ISMS management review',
  description:
    'Top management shall review the ISMS. Review inputs include: audit results, risk assessment status, corrective actions, and improvement opportunities.',
  category: 'governance',
  scfIds: ['SCF-MSS-006'],
  cadence: { frequency: '6m', anchor: 'domain' },
  // GH #6698, co-owner review. Was `strategy: 'any'`, which made this the
  // second-largest remaining instance of the defect this PR exists to fix.
  //
  // Under `any`, `canAutoComplete` is `passCount > 0`. So publishing a
  // document mapped to this control fulfilled the obligation on its own,
  // while `management-review-conducted` failed AND the
  // attestation "Confirm the ISMS management review meeting actually took place" failed —
  // and Gate 5 reads only the obligation's status, so "Obligations current"
  // passed. ISO 27001 clause 9.3 read as met from a published document and nothing else.
  //
  // This is the same decision the three `obl-subprocessor-*` obligations took
  // in this PR, and the same doctrine: a published document is evidence a
  // procedure exists, never proof the activity happened.
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'management-review-conducted',
      description: 'A management review meeting was logged and completed within the current cycle',
    },
    {
      type: 'document-published',
      description: 'ISMS management review minutes or report is published',
    },
    {
      type: 'manual-attestation',
      description: 'Confirm the ISMS management review meeting actually took place',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
